import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueI18n from 'vue-i18n';
import VueHead from 'vue-head';
import vueHeadful from 'vue-headful';
//import VueMeta from 'vue-meta'

Vue.config.productionTip = false

Vue.use(VueI18n);
Vue.use(BootstrapVue);
Vue.use(VueHead);
Vue.component('vue-headful', vueHeadful);
//Vue.use(VueMeta, {
// optional pluginOptions
//refreshOnceOnNavigation: true
//})

const data = require('../traduction.json');
require('@/assets/main.scss');


const i18n = new VueI18n({
  locale: 'ja',
  messages: data,
})
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')